<template>
  <header class="mb-10 max-w-2xl mx-auto">
    <h1 class="hero-title text-brand mb-2">
      <span class="block me-2">{{ page.title }}</span>
      <span>{{ page.meta?.subtitle }}</span>
    </h1>
    <ContentRenderer class="text-brand/66" :value="page" />
  </header>
  <p class="text-brand mb-8">
    {{ config.opening_hours.human }}
  </p>
  <p class="mb-8">
    <a
      :href="config.contact.address.url"
      class="text-brand border-bottom inline-flex border-b-1 border-dotted"
    >
      <MapPinIcon class="size-6 me-2" />
      {{ config.contact.address.human }}
    </a>
  </p>
  <p
:class="{
      'mb-4': config.gift_voucher.enabled,
      'mb-18': !config.gift_voucher.enabled
  }">
    <a
      :href="config.booking_url"
      class="btn btn-secondary btn-lg"
    >
      {{ t('booking.label') }}
    </a>
  </p>
  <p v-if="config.gift_voucher.enabled" class="mb-18">
    <NuxtLink
      :href="giftVoucherUrl"
      class="btn btn-outline-secondary btn-lg"
    >
      {{ page.meta.gift_voucher_cta }}
    </NuxtLink>
  </p>
</template>
<script setup lang="ts">
import {MapPinIcon} from "@heroicons/vue/24/outline";
import {menuMainItems} from "~~/route/route.config";
const { t, locale } = useI18n();
const {collectionUri} = useI18nCollection();
const config = useRuntimeConfig().public;

const page = await queryCollection(collectionUri('home')).first();

const giftVoucherUrl = computed<string>(() => menuMainItems.find(i => i.identifier === config.gift_voucher.uri)?.path?.[locale.value] || '/gift-card');

</script>